// apps/web/src/api/practice.ts
// 练习相关 API — 调用 /api/v1/practice/*

import api from "./client";
import type {
  StartPracticeResponse,
  SubmitAnswerResponse,
  QuestionPracticeStatsDTO,
  SyncPracticeAnswerItem,
  SyncPracticeAnswersResponse,
} from "@examfast/shared-types";

const BASE = "practice";

/** 开始练习 */
export async function startPracticeApi(data: {
  bank_id: string;
  mode: string;
  settings?: Record<string, unknown>;
}): Promise<StartPracticeResponse> {
  return api.post<StartPracticeResponse>(`${BASE}/start`, data);
}

/** 提交答案 */
export async function submitAnswerApi(
  sessionId: string,
  data: {
    question_id: string;
    user_answer: string | string[] | boolean;
    time_spent_seconds: number;
  }
): Promise<SubmitAnswerResponse> {
  return api.post<SubmitAnswerResponse>(`${BASE}/${sessionId}/answer`, data);
}

export async function syncPracticeAnswersApi(
  sessionId: string,
  answers: SyncPracticeAnswerItem[]
): Promise<SyncPracticeAnswersResponse> {
  return api.post<SyncPracticeAnswersResponse>(`${BASE}/${sessionId}/answers/batch`, { answers });
}

export async function getQuestionPracticeStatsApi(questionId: string): Promise<QuestionPracticeStatsDTO> {
  return api.get<QuestionPracticeStatsDTO>(`${BASE}/questions/${questionId}/stats`);
}

/** 完成练习 */
export async function completeSessionApi(sessionId: string): Promise<{
  score: number;
  correct_count: number;
  total_count: number;
}> {
  return api.post(`${BASE}/${sessionId}/complete`, {});
}

/** 获取会话状态 */
export async function getSessionApi(sessionId: string): Promise<{
  id: string;
  mode: string;
  score: number | null;
  correct_count: number;
  total_count: number;
  status: string;
  started_at: number;
  completed_at: number | null;
}> {
  return api.get(`${BASE}/${sessionId}`);
}
